import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-131c720a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-container" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Professional Summary"),
  /*#__PURE__*/_createElementVNode("p", null, " Full Stack Software Engineer with over 6 years of experience in developing web applications. Skilled in front-end development with Vue.js, Angular, and TypeScript, and proficient in back-end technologies including Node.js, Express, Kotlin, and Spring Boot. Expertise in designing and implementing RESTful APIs and database solutions with PostgreSQL. Leverages AI technologies like ChatGPT for debugging and research, accelerating development timelines. ")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_3 = { class: "summary-tech-images" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src", "alt", "title"]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { ImageLink } from '../../../models/sections/summary'
import { v4 as uuid } from 'uuid'

type ImageAndCreatedImageUrl = ImageLink & { imageUrl?: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'SummarySection',
  setup(__props) {

const store = useStore()
const urls = ref<ImageAndCreatedImageUrl[]>([])
const links = computed(() => store.getters['summary/getLinks'])
const timeouts = ref<any[]>([])

const getKey = (name?: string): string =>
  'summary-image-' + name?.toLowerCase()?.replaceAll(' ', '_') + uuid()

const getAndSetImage = async (item: ImageAndCreatedImageUrl) => {
  if (!item?.imageUrl) {
    item.imageUrl = await store.dispatch('summary/getTechImage', item.name)
  }
  const urlIndex = urls.value.findIndex((url) => url.name === item.name)
  urls.value[urlIndex] = item
}

watch(links, async (items) => {
  // This helps trigger the visuals :)
  let waitInMs = 50
  for (const item of items) {
    timeouts.value.push(setTimeout(() => getAndSetImage(item), waitInMs))
    urls.value.push(item)
    waitInMs += 100
  }
})

onMounted(() => store.dispatch('summary/getSummaryTechLinks'))
onUnmounted(() =>
  timeouts.value.forEach((timeout: any) => clearTimeout(timeout))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urls.value, (urlObject) => {
        return (_openBlock(), _createElementBlock("div", {
          key: getKey(urlObject.name),
          class: "tech-image"
        }, [
          (urlObject?.imageUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: urlObject.imageUrl,
                  alt: urlObject.name,
                  title: urlObject.name + ' icon',
                  type: "image/png"
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})